export default __webpack_public_path__ + "static/media/tvbizz-logo-new.aaa911b3.svg";